import React, { useEffect, useState } from 'react'

const InputPrice = ({ name, value, onChange, ...propsInput }) => {
  const [internalValue, setInternalValue] = useState(
    value !== null ? value?.toString() : '',
  )

  useEffect(() => {
    setInternalValue(value !== null ? value?.toString() : '')
  }, [value])

  const onChangePrice = (e) => {
    let targetValue = e.target.value
    // Replace comma with a period for decimal
    targetValue = targetValue.replace(',', '.')

    // Remove all non-numeric characters except for '-' and '.'
    targetValue = targetValue.replace(/[^0-9.-]/g, '')

    // Handle multiple '-' or '.' characters
    const firstDashIndex = targetValue.indexOf('-')
    if (firstDashIndex > 0) {
      // If '-' is not at the beginning, remove it
      targetValue = targetValue.replace(/-/g, '')
    } else if (firstDashIndex === 0) {
      // If '-' is at the beginning, remove all subsequent occurrences
      targetValue = '-' + targetValue.slice(1).replace(/-/g, '')
    }

    const parts = targetValue.split('.')
    // Limit decimal places to 3
    if (parts[1]?.length > 3) {
      parts[1] = parts[1].slice(0, 3)
    }

    // Reconstruct the value ensuring only one decimal part
    targetValue = parts.length > 1 ? `${parts[0]}.${parts[1]}` : parts[0]

    // Special case for '-.'
    if (targetValue === '-.') {
      targetValue = '-0.'
    }

    // Allow '-', '-0', '-0.', '-0.0', and other valid numbers
    const regex = /^-?(\d+)?(\.\d{0,3})?$/
    if (regex.test(targetValue)) {
      // Update the internal state to reflect the formatted value
      setInternalValue(targetValue)

      // Convert to float, or set to undefined if empty or only '-'
      const convertedValue =
        targetValue !== '' &&
        targetValue !== '.' &&
        targetValue !== '-' &&
        targetValue !== '-0.' &&
        targetValue !== '-0.0' &&
        targetValue !== '-0'
          ? parseFloat(targetValue)
          : undefined

      // Trigger the onChange event with the updated value
      onChange({ target: { name: e.target.name, value: convertedValue } })
    } else {
      setInternalValue(targetValue)
    }
  }

  return (
    <span
      className={`
                p-inputnumber p-component p-inputwrapper p-inputwrapper-filled
                ${propsInput.isDisabled ? ' p-disabled' : ''}`}
      data-pc-name="inputnumber"
      data-pc-section="root"
    >
      <input
        className="p-inputnumber-input p-inputtext p-component p-filled p-inputnumber-input"
        role="spinbutton"
        type="text"
        inputMode="decimal"
        data-pc-name="inputtext"
        data-pc-section="root"
        value={internalValue}
        name={name}
        onChange={onChangePrice}
        {...propsInput}
      />
      €
    </span>
  )
}

export default InputPrice
